/* eslint-disable no-shadow */
import { createTypes, completeTypes, withPostSuccess, withPostFailure } from 'redux-recompose';
import { push } from 'connected-react-router';

import { getKDSPolicies, hasAccessToKds } from '~utils/policies';
import CoreActions from '~redux/Core/actions';
import { SIDEBAR_ITEMS } from '~components/SideBar/constants';
import OrderActions from '~redux/Order/actions';
import { ROUTES } from '~constants/routes';
import { setTokenHeader } from '~config/api';
import LocalStorage from '~services/LocalStorageService';

import UserService from '../../services/AdminUser/service';

import { getItem, userPoliciesMapper } from './mapper';

export const actions = createTypes(
  completeTypes(['GET_CURRENT_USER', 'SET_KDS_ACCESS', 'SET_USER_POLICIES', 'SET_USER_ACTIONS'], []),
  '@@ADMIN_USER'
);
const targets = {
  ADMIN_USER: 'adminUser',
  KDS_ACCESS: 'kdsAccess',
  USER_ACTIONS: 'userActions',
  USER_POLICIES: 'userPolicies'
};
const actionCreators = {
  getCurrentUser: () => (dispatch, getState) =>
    dispatch({
      type: actions.GET_CURRENT_USER,
      target: targets.ADMIN_USER,
      service: UserService.getCurrentUser,
      injections: [
        withPostSuccess(() => {
          const state = getState();
          const {
            adminUser: { adminUser }
          } = state;
          dispatch(actionCreators.setUserPolicies());
          dispatch(actionCreators.setUserActions());
          dispatch(actionCreators.setKdsAccess());
          dispatch(CoreActions.setStoreSelected());
          dispatch(OrderActions.getOrders(adminUser?.storeIds[0], SIDEBAR_ITEMS.CREATED.status, 1));
        }),
        withPostFailure((dispatch) => {
          setTokenHeader(null);
          LocalStorage.setTokenManager(null);
          dispatch(push(ROUTES.LOGIN.path));
        })
      ]
    }),
  setUserPolicies: () => (dispatch, getState) => {
    const { adminUser } = getState().adminUser;
    const payload = getKDSPolicies(adminUser);
    dispatch({
      type: actions.SET_USER_POLICIES,
      target: targets.USER_POLICIES,
      payload
    });
  },
  setKdsAccess: () => (dispatch, getState) => {
    const { userPolicies, adminUser } = getState().adminUser;
    const payload = hasAccessToKds(userPolicies, adminUser);
    if (payload) {
      return dispatch({
        type: actions.SET_KDS_ACCESS,
        target: targets.KDS_ACCESS,
        payload
      });
    }
    setTokenHeader(null);
    LocalStorage.setTokenManager(null);
    dispatch(push(ROUTES.LOGIN.path));
  },
  setUserActions: () => (dispatch, getState) => {
    const { userPolicies } = getState().adminUser;
    const payload = userPoliciesMapper(userPolicies);
    const keysArray = Object.keys(SIDEBAR_ITEMS);
    const valuesArray = Object.values(SIDEBAR_ITEMS);
    const itemSelected = keysArray[getItem(userPolicies, valuesArray)];
    dispatch({
      type: actions.SET_USER_ACTIONS,
      target: targets.USER_ACTIONS,
      payload
    });
    dispatch(OrderActions.setActiveTab(itemSelected));
  }
};
export default actionCreators;
